import { analyticsEventTypes } from 'events/analytics';
import { WIDGET_CLOSED_EVENT } from 'GladlySidekickConstants';

export default function widgetClosed() {
  return {
    [analyticsEventTypes.WIDGET_CLOSED]: () => {
      return [
        {
          eventName: WIDGET_CLOSED_EVENT,
          eventPayload: [],
        },
      ];
    },
  };
}
